var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-wrapper"},[_c('div',{staticClass:"auth-container"},[_vm._t("auth-container")],2),_c('p',{staticClass:"copyright"},[_vm._v(" 版权所有：成都运荔枝科技有限公司 备案号：蜀ICP备19017829号-1 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }